import { BILLING_ACTION } from '../../constants/actions'

const changeBillingState = (property, value) => ({
  type: BILLING_ACTION.ON_CHANGE_STATE,
  payload: {
    property,
    value
  }
})

const generateCheckoutSession = (priceId) => ({
  type: BILLING_ACTION.ON_GENERATE_CHECKOUT_SESSION,
  payload: {
    priceId
  }
})

const generateViewBillingSession = () => ({
  type: BILLING_ACTION.ON_GENERATE_VIEW_BILLING_SESSION
})

const getExchangePerformance = () => ({
  type: BILLING_ACTION.ON_GET_EXCHANGE_PERFORMANCE
})

export {
  changeBillingState,
  generateCheckoutSession,
  generateViewBillingSession,
  getExchangePerformance
}
